<template>
    <div class="bg-0A1129 text-white min-vh-100 d-flex flex-column">
      <Mainlayout />
  
      <!-- Centered content -->
      <div class="flex-grow-1 d-flex mt-5 align-items-center justify-content-center">
        <br /> <br /> <br /> <br />
        <div class="text-center p-4 mt-5">
            <div class="text-center">
                <img src="../assets/img/vectorsuccess.png" width="135" height="135" />
          <h3 class="text-white mt-3">Pembayaran Berjaya</h3>
          <h5 class="text-white mt-2">
            Pembayaran anda telah berjaya diproses. Terima kasih atas pembelian anda!<br />
            Untuk menyemak status pembelian, sila klik butang <strong>"Jejak Pembayaran"</strong>.<br />
            Sila login menggunakan email <strong>{{ email }}</strong>. <br />Info berkaitan email telah di emelkan di email tersebut.
          </h5>
          <div class="mt-4">
            <CButton type="button" class="text-white me-2" @click="GoToProduct()">Tutup</CButton>
            <CButton type="button" class="bg-1796FD text-white" @click="GoToExistingDashboard()">Jejak Pembayaran</CButton>
          </div>
            </div>
         
        </div>
      </div>
  
      <Footer />
    </div>
  </template>

<script>
import Vue from "vue";
import _ from "lodash";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "@/containers/AllHeader.vue";
import Footer from "@/components/Footer.vue";
export default {

  name: "Payment",
  components: {
      Mainlayout,
      Footer,

  },
  data() {
      return {
        account: this.$route.query.accountId,
        user:{},
        email: ""
      }
    },
    mounted() {
            this.GetInfoUser();
    },
    methods:
    {
        GoToProduct()
        {
            this.$router.push("OurProduct");
        },
        GoToExistingDashboard()
        {

            window.open("https://app.flyhigh.my/v3/#/EditProfile");

        },
        GetInfoUser() {
          this.$API
            .get(this.$LoginUserDetailWoLogin + "?userId=" + this.account)
            .then((response) => {
              this.user = response.data;
              this.email = this.user.data.email;
              console.log("user " + JSON.stringify(this.user));
              
            })
            .catch((error) => {
              if (error.response) {
                console.log(error.response);
                this.Error = true;
                this.Message = error;
                this.Message = "Sila lengkapkan borang pendaftaran";
              }
            });
        },
    }
}
</script>
